import { Chip } from '@mui/material';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';
import { currentContextAtom } from '../../../state';
import FilterUtils, { toggleUiStateFilter } from '../../../search/filters/filter.utils';
import useRefine from '../../../hooks/useRefine';

export default function CompanyDeliveryInMyAreaFilterTag(): React.JSX.Element {
  const { t } = useTranslation(['discovery']);
  const { refine, uiState } = useRefine();
  const { companyAddress } = useAtomValue(currentContextAtom);
  const deliveryZoneFilter = ` AND ${FilterUtils.GetSupplierCanDeliverFilter(companyAddress.administrativeAreaLevel2!)}`;

  const handleDeleteDeliverFilter = useCallback((): void => {
    refine({
      filters: toggleUiStateFilter(uiState.filters!, deliveryZoneFilter),
    });
  }, [uiState, refine]);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {uiState.filters?.includes(deliveryZoneFilter) && (
        <Chip
          label={t('discovery:that_deliver_my_area')}
          onDelete={handleDeleteDeliverFilter}
          variant="filter"
        />
      )}
    </>
  );
}
